import React, { useState, useEffect } from "react";
import { ref, get } from "firebase/database";
import { database as db } from "../../FirebaseConfig"; // Adjust based on your Firebase config
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import { useNavigate } from "react-router-dom";

const KnowledgeHub = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const navigate = useNavigate();

  const handleClick = (id)=>{

    navigate(`/blog?id=${id}`);

  }
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const snapshot = await get(ref(db, "blogs")); // Fetch from 'blogs' node in Realtime Database
        if (snapshot.exists()) {
          const data = snapshot.val();
          const formattedData = Object.keys(data).map((key) => ({
            id: key,
            ...data[key],
          }));
          setBlogPosts(formattedData);
        }
      } catch (error) {
        console.error("Error fetching blog posts:", error);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className="relative  bg-yellow-50 overflow-hidden">
      {/* Internal CSS for Meteor Effect */}
      <style jsx>{`
        @keyframes meteor {
          0% { transform: translate(-200px, -200px) rotate(45deg); opacity: 0.3; }
          30% { opacity: 0.5; }
          70% { opacity: 0.2; }
          100% { transform: translate(500px, 500px) rotate(45deg); opacity: 0; }
        }
        .meteor {
          position: absolute;
          width: 150px;
          height: 3px;
          background: linear-gradient(90deg, #FFB800, #FFE082);
          animation: meteor 5s linear infinite;
        }
        .background-gradient {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, #FFF8E1 0%, #FFE082 100%);
          pointer-events: none;
        }
      `}</style>

      {/* Background gradient */}
      <div className="background-gradient"></div>

      {/* Meteor Effects */}
      {[...Array(15)].map((_, i) => (
        <div
          key={i}
          className="meteor"
          style={{
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`,
            opacity: 0.3,
          }}
        />
      ))}

      {/* Content */}
      <div className="container mx-auto px-4 py-16 relative z-10">
        <h1 className="text-xl md:text-4xl font-bold text-gray-800 text-center mb-4">
          TGHC KNOWLEDGE BASE
        </h1>
        <p className="text-sm text-gray-700 text-center mb-8">
          Everything you need to know about modern beekeeping in one place
        </p>

        {/* Mobile View: Horizontal Scrolling */}
        {/* Mobile View: Horizontal Scrolling */}
<div className="block md:hidden">
  <Swiper
    slidesPerView={"auto"}
    spaceBetween={10}
    freeMode={true}
    autoplay={{
      delay: 2500,
      disableOnInteraction: false,
    }}
    modules={[FreeMode, Autoplay]}
    className="px-2"
  >
    {blogPosts.map((post) => (
      <SwiperSlide
      onClick={()=>handleClick(blogPosts.id)}
        key={post.id}
        className="min-w-[280px] max-w-[300px]"
      >
        <div className="h-[420px] bg-white rounded-lg overflow-hidden hover:scale-105 transition-transform duration-300 shadow-lg flex flex-col">
          <img src={post.thumbnail} alt={post.title} className="w-full h-40 object-cover" />
          <div className="p-4 flex flex-col flex-grow">
            <div className="text-gray-600 text-sm mb-2">{post.date}</div>
            <h2 className="text-lg font-bold text-gray-800 mb-2">{post.title}</h2>
            <p className="text-gray-700 text-sm flex-grow">{post.summary}</p>
          </div>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
</div>

{/* Desktop View: Grid Layout */}
<div className="hidden md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
  {blogPosts.map((post) => (
    <div onClick={()=>{handleClick(post.id)}} key={post.id} className="h-[420px] bg-white rounded-lg overflow-hidden hover:scale-105 transition-transform duration-300 shadow-lg flex flex-col">
      <img src={post.thumbnail} alt={post.title} className="w-full h-48 object-cover" />
      <div className="p-6 flex flex-col flex-grow">
        <div className="text-gray-600 text-sm mb-2">{post.date}</div>
        <h2 className="text-xl font-bold text-gray-800 mb-3">{post.title}</h2>
        <p className="text-gray-700 flex-grow">{post.summary}</p>
      </div>
    </div>
  ))}
</div>

    </div>
    </div>
  );
};

export default KnowledgeHub;
